import React from 'react';
import { twMerge } from 'tailwind-merge';
import classnames from 'classnames';
import { DeleteIcon, EditIconBlue } from 'assets/icons';
import LineItemPlusReactIcon from 'assets/react-icons/LineItemPlusReactIcon';
import { CustomSwitch } from 'components';

interface TermsAndConditionsSectionProps {
  editTnc: boolean;
  tnc: {
    enabled: boolean;
    tnc: string;
  };
  toggleTerms: () => void;
  handlEditTermsClick: () => void;
  handlDeleteTermsClick: () => void;
  handlAddTermsClick: () => void;
  texts: {
    title: string;
    switchLabel: string;
    emptyStateDescription: string;
    addButtonText: string;
  };
}

const TermsAndConditionsSection = ({
  editTnc,
  tnc,
  toggleTerms,
  handlEditTermsClick,
  handlDeleteTermsClick,
  handlAddTermsClick,
  texts
}: TermsAndConditionsSectionProps) => {
  return (
    <div
      className={twMerge(
        classnames({
          'pointer-events-none opacity-50': !editTnc
        })
      )}>
      <div className="flex items-center justify-between">
        <div>
          <div className="mb-2 text-xl font-bold text-primaryText">{texts.title}</div>
          <div className="text-[17px] font-normal text-primaryText">{texts.switchLabel}</div>
        </div>
        <CustomSwitch enabled={tnc?.enabled} toggleSwitch={toggleTerms} id="tnc-switch" />
      </div>
      {tnc && tnc.tnc ? (
        <div className="mt-3 border border-borderGray p-5">
          <div
            className="customNormalScroll max-h-[160px] overflow-y-auto
                       whitespace-pre-line break-words text-sbase font-normal text-primaryText">
            {tnc.tnc}
          </div>
          <div className="mt-3 flex items-center justify-end">
            <div className="flex items-center">
              <div
                className="flex cursor-pointer items-center text-17px font-semibold text-secondary"
                role="presentation"
                onClick={handlEditTermsClick}>
                <EditIconBlue className="h-5 w-5" />
                <div className="ml-1">Edit</div>
              </div>
              <div
                className="ml-[30px] flex cursor-pointer items-center text-17px font-semibold text-error"
                role="presentation"
                onClick={handlDeleteTermsClick}>
                <DeleteIcon className="h-5 w-5" />
                <div className="ml-1">Delete</div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="mt-3 text-17px font-normal text-primaryText">{texts.emptyStateDescription}</div>
          <div className="mt-5 flex cursor-pointer items-center" role="presentation" onClick={handlAddTermsClick}>
            <LineItemPlusReactIcon id="discount-tips-add-text" />
            <div className="ml-2 text-17px font-semibold text-secondary">{texts.addButtonText}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default TermsAndConditionsSection;
